module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "scrollContainer",
    staticClass: "app-container",
    on: {
      "scroll": function($event) {
        return _vm.onScroll($event)
      }
    }
  }, [_c('div', {
    staticClass: "app-wrapper inner bg-light"
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "scroll-more-container"
  }, [_c('div', {
    staticClass: "btn btn-block text-center text-muted"
  }, [(!_vm.status.infiniting && !_vm.status.isInfinite) ? _c('span', [_vm._v("没有更多了")]) : _vm._e(), _vm._v(" "), (!_vm.status.infiniting && _vm.status.isInfinite && !_vm.status.loading) ? _c('span') : _vm._e(), _vm._v(" "), (_vm.status.infiniting) ? _c('span', [_vm._v("加载中...")]) : _vm._e()])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34af5890"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/template/scroll.vue
// module id = 274
// module chunks = 107